import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddReadingBatchLevelComponent } from './add-reading-batch-level/add-reading-batch-level.component';

@Component({
  selector: 'app-reading-batch-level',
  templateUrl: './reading-batch-level.component.html',
  styleUrls: ['./reading-batch-level.component.scss']
})
export class ReadingBatchLevelComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.READING_LEVEL;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public store: BookstoreStore,
    private route: ActivatedRoute,
    private storage: FireStorageService
  ) { }

  ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    this.store.fetchData(COLLECTION_NAME.READING_BATCH_LEVEL, this.DISPLAY_STATUS_KEY.key)
  }


  create(item?: any) {
    let dialogRef = this.dialog.open(AddReadingBatchLevelComponent, {
      data: { ITEM: item || null },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  delete(item: any) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: `Delete Level`,
        memo: `Level will permanently drop from app.`,
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        if (item.fileDetail) {
          await this.storage.storageRef(item.fileDetail.filename).delete().toPromise();
        }
        this.store.deleteItem(COLLECTION_NAME.READING_BATCH_LEVEL, item, (success, error) => {
          if (success) {
            this.snackBar.open(`Level has been deleted.`, 'done', { duration: 2000 });
            this.store.fetchData(COLLECTION_NAME.READING_BATCH_LEVEL, this.DISPLAY_STATUS_KEY.key)
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }

}
